export default {"src":"/uk/_next/static/media/up-filled.fe45e001.svg","height":14,"width":14,"blurWidth":0,"blurHeight":0};